//Util
import { MEDIA_DEVICE_SMALL } from "util/constants";

//Hooks
import { useMediaQuery } from "./media-query";

export const useIsSmallDevice = (): boolean => {
  return useMediaQuery(MEDIA_DEVICE_SMALL);
};
